<div class="usa-modal__content">
  <div class="usa-modal__main" style="width:100% !important">
    <h2 class="usa-modal__heading" id="modal-2-heading">
      Extra Pickup / Delivery Addresses
    </h2>
    <div ng-controller="ModalCtrl">
      <div class="usa-prose">
        <form [formGroup]='hhgpickupDeliveryAddressForm'>
          <div id="modal-2-description">
            You have unsaved changes that will be lost.
          </div>
          <div class="modal-2-description">
            Shipment Id: {{ shipmentsId }}
          </div>
          @for (item of hhgpickupDeliveryAddressForm.get('addressInfo')['controls']; track item; let i = $index) {
            <div formArrayName="addressInfo">
              <div [formGroupName]="i">
                <div class="grid-row grid-gap-1">
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <legend class="usa-legend usa-legend--medium">Address {{i+1}}</legend>
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label">Pickup / Delivery Type<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                    <select class="usa-select maxw-full" formControlName="pickDelType">
                      <option value='' selected>None</option>
                      @for (type of pickupDeliveryType; track type) {
                        <option [value] = "type">{{type}}</option>
                      }
                    </select>
                    @for (validation of validationMessages.pickDelType; track validation) {
                      @if (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('pickDelType').hasError(validation.type) && (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('pickDelType').dirty || hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('pickDelType').touched)) {
                        <div class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> {{validation.message}}
                        </div>
                      }
                    }
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                    <div class="grid-row grid-gap-1">
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                        <label class="usa-label">
                          Address Line 1 <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                        </label>
                        <input type="text" placeholder="Enter Value Here" class="usa-input maxw-full" formControlName="addLine1">
                        @for (validation of validationMessages.addLine1; track validation) {
                          @if (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('addLine1').hasError(validation.type) && (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('addLine1').dirty || hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('addLine1').touched)) {
                            <div class="define-text-secondary">
                              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg> {{validation.message}}
                            </div>
                          }
                        }
                      </div>
                      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                        <label class="usa-label">Address Line 2</label>
                        <input type="text" placeholder="Enter Value Here" class="maxw-full usa-input" formControlName="addLine2">
                      </div>
                    </div>
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label">City <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                    <input type="text" placeholder="Enter Value Here" class="maxw-full usa-input" formControlName="city">
                    @for (validation of validationMessages.city; track validation) {
                      @if (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('city').hasError(validation.type) && (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('city').dirty || hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('city').touched)) {
                        <div class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> {{validation.message}}
                        </div>
                      }
                    }
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label">State <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                    <select formControlName="state" class="usa-select maxw-full">
                      @for (origState of allStatesList; track origState) {
                        <option [value] = "origState.stateCountryName">{{origState.stateCountryName}}
                        </option>
                      }
                    </select>
                    @for (validation of validationMessages.state; track validation) {
                      @if (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('state').hasError(validation.type) && (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('state').dirty || hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('state').touched)) {
                        <div class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> {{validation.message}}
                        </div>
                      }
                    }
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label">Zip <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                    <input type="text" placeholder="Enter Value Here" class="usa-input maxw-full" formControlName="zip">
                    @for (validation of validationMessages.zip; track validation) {
                      @if (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('zip').hasError(validation.type) && (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('zip').dirty || hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('zip').touched)) {
                        <div class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> {{validation.message}}
                        </div>
                      }
                    }
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label">Country <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                    <select formControlName="country" class="usa-select maxw-full">
                      @for (origCountry of allCountriesList; track origCountry) {
                        <option [value] = "origCountry.stateCountryName"
                          >{{origCountry.stateCountryName}}
                        </option>
                      }
                    </select>
                    @for (validation of validationMessages.country; track validation) {
                      @if (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('country').hasError(validation.type) && (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('country').dirty || hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('country').touched)) {
                        <div class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> {{validation.message}}
                        </div>
                      }
                    }
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label">
                      Primary Phone <abbr title="required" class="usa-hint usa-hint--required">*</abbr>
                    </label>
                    <input type="text" placeholder="Enter Value Here" class="maxw-full usa-input" formControlName="primaryPhone">
                    @for (validation of validationMessages.primaryPhone; track validation) {
                      @if (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('primaryPhone').hasError(validation.type) && (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('primaryPhone').dirty || hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('primaryPhone').touched)) {
                        <div class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> {{validation.message}}
                        </div>
                      }
                    }
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label">Alternate Phone</label>
                    <input type="text" placeholder="Enter Value Here" class="usa-input maxw-full" formControlName="alternatePhone">
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label">Email</label>
                    <input type="email" placeholder="Enter Value Here" class="maxw-full usa-input" formControlName="email">
                    @for (validation of validationMessages.email; track validation) {
                      @if (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('email').hasError(validation.type) && (hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('email').dirty || hhgpickupDeliveryAddressForm.get('addressInfo').controls[i].get('email').touched)) {
                        <div class="define-text-secondary">
                          <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> {{validation.message}}
                        </div>
                      }
                    }
                  </div>
                  <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
                    <label class="usa-label">Other Contact Information</label>
                    <input type="text" placeholder="Enter Value Here" class="maxw-full usa-input" formControlName="otherContactInfo">
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="grid-row grid-gap-1 padding-top-4">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 text-center">
              <button type="button" class="usa-button" [disabled]="redirectedFromBol" (click)="addMoreAddress()">Add
              Address</button>
            </div>

            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-4">
              <button type="button" class="usa-button" [disabled]="!(hhgpickupDeliveryAddressForm.valid && !redirectedFromBol)" (click)="saveaddress()">Save</button>
              <button type="button" class="usa-button usa-button--outline margin-left-2" (click)="cancelAddress()">Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <button class="usa-button usa-modal__close" aria-label="Close this window" (click)="cancelAddress()">
    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
      <use xlink:href="/assets/uswds/img/sprite.svg#close"></use>
    </svg>
  </button>
</div>